export default __webpack_public_path__ + "img/united-states-flag.3b5a3c1c.svg";